import { PermissionsScope } from "@/common/types/permissions.types";
import { Step } from "@/components/Contracts/components/ItemReplacement/types/contractItem.interface";
import { IUserInfo } from "@/components/Shared/Layouts/components/FreshChat/interfaces/fresh-chat.interface";
import { ActionsLogsEnum } from "@/modules/Settings/pages/InventoriesOccurrences/inventoryOccurrencesConfig";

enum TermsActionsLogsEnum {
  CREATED = "CREATED",
  SIGNATURES_ADDED = "SIGNATURES_ADDED",
  STATUS_CHANGED = "STATUS_CHANGED",
  STATUS_CHANGED_BY_DIGITAL_SIGNATURE = "STATUS_CHANGED_BY_DIGITAL_SIGNATURE"
}

export interface ITermLogs {
  id: number;
  termId: number;
  logType: TermsActionsLogsEnum;
  createdAt: Date;
  scope: PermissionsScope;
  action: ActionsLogsEnum;
  user?: IUserInfo;
  userAgent?: string;
  currentStep?: Step;
  nextStep?: Step;
  statusChangeReason?: string;
}

export const TermActionTranslate: Record<TermsActionsLogsEnum, string> = {
  [TermsActionsLogsEnum.CREATED]: "Criado",
  [TermsActionsLogsEnum.SIGNATURES_ADDED]:
    "Assinatura(s) digital(ais) adicionada(s)",
  [TermsActionsLogsEnum.STATUS_CHANGED]: "Estado alterado",
  [TermsActionsLogsEnum.STATUS_CHANGED_BY_DIGITAL_SIGNATURE]:
    "Estado alterado por assinatura(s)"
};

export const TermsActionsLogsTypeDotColor: Record<
  TermsActionsLogsEnum,
  string
> = {
  CREATED: "green",
  SIGNATURES_ADDED: "blue",
  STATUS_CHANGED: "green",
  STATUS_CHANGED_BY_DIGITAL_SIGNATURE: "green"
};
